import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';
import styles from './AllowanceModelPendingIllustration.module.scss';

const PILL_ROWS = [
  { className: styles['pillRow1'], y: 41.5 },
  { className: styles['pillRow2'], y: 68.5 },
  { className: styles['pillRow3'], y: 95.5 },
  { className: styles['pillRow4'], y: 122.5 },
];

const PILL_COLUMNS = [
  { x: 14, width: 27 },
  { x: 68.67, width: 31 },
  { x: 123.33, width: 24 },
];

export const AllowanceModelPendingIllustration = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="164"
        height="164"
        viewBox="0 0 164 164"
        fill="none"
        overflow="visible"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="164"
          height="164"
          rx="12"
          fill="white"
          filter="url(#allowance_model_pending_card_shadow)"
        />
        <g clipPath="url(#allowance_model_pending_card_clip)">
          <rect width="164" height="30" fill="#F7F9FB" />
          <rect x="54.67" y="30" width="1" height="108" fill="#EDEFF6" />
          <rect x="109.33" y="30" width="1" height="108" fill="#EDEFF6" />
          <rect y="30" width="164" height="1" fill="#EDEFF6" />
          <rect y="57" width="164" height="1" fill="#EDEFF6" />
          <rect y="84" width="164" height="1" fill="#EDEFF6" />
          <rect y="111" width="164" height="1" fill="#EDEFF6" />
          {PILL_ROWS.map(({ className, y }) => (
            <g key={y} className={className}>
              {PILL_COLUMNS.map(({ x, width }) => (
                <rect
                  key={x}
                  x={x}
                  y={y}
                  width={width}
                  height="4"
                  rx="2"
                  fill="#EDEFF6"
                />
              ))}
            </g>
          ))}
          <g className={styles['file']}>
            <g transform="translate(115.06, 35.88) rotate(-22.93) translate(-12.86, -16.29)">
              <path
                d="M21.4286 31.7143H4.28571C3.3764 31.7143 2.50433 31.3531 1.86135 30.7101C1.21837 30.0671 0.857143 29.195 0.857143 28.2857V4.28571C0.857143 3.3764 1.21837 2.50433 1.86135 1.86135C2.50433 1.21837 3.3764 0.857143 4.28571 0.857143H14.8656C15.7749 0.857143 16.6469 1.21837 17.2899 1.86135L23.8529 8.42437C24.4959 9.06735 24.8571 9.93942 24.8571 10.8487V28.2857C24.8571 29.195 24.4959 30.0671 23.8529 30.7101C23.21 31.3531 22.3379 31.7143 21.4286 31.7143Z"
                fill="#275853"
              />
              <path
                d="M9.42857 16.2857L16.2857 24.8571M9.42857 24.8571L16.2857 16.2857M21.4286 31.7143H4.28571C3.3764 31.7143 2.50433 31.3531 1.86135 30.7101C1.21837 30.0671 0.857143 29.195 0.857143 28.2857V4.28571C0.857143 3.3764 1.21837 2.50433 1.86135 1.86135C2.50433 1.21837 3.3764 0.857143 4.28571 0.857143H14.8656C15.7749 0.857143 16.6469 1.21837 17.2899 1.86135L23.8529 8.42437C24.4959 9.06735 24.8571 9.93942 24.8571 10.8487V28.2857C24.8571 29.195 24.4959 30.0671 23.8529 30.7101C23.21 31.3531 22.3379 31.7143 21.4286 31.7143Z"
                stroke="#275853"
                strokeWidth="1.71429"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.42868 14.2857L16.2858 22.8571M9.42868 22.8571L16.2858 14.2857"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.8385 26.9095L35.5242 35.8135C35.6753 35.9118 35.6294 36.1442 35.4523 36.1777L28.2162 37.545L24.4705 43.525C24.3739 43.6793 24.1383 43.6348 24.1045 43.456L21.0745 27.4214C20.9928 26.9889 21.4695 26.6694 21.8385 26.9095Z"
                fill="#1A1721"
              />
              <path
                d="M21.8385 26.9095L35.5242 35.8135C35.6753 35.9118 35.6294 36.1442 35.4523 36.1777L28.2162 37.545L24.4705 43.525C24.3739 43.6793 24.1383 43.6348 24.1045 43.456L21.0745 27.4214C20.9928 26.9889 21.4695 26.6694 21.8385 26.9095Z"
                stroke="white"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <defs>
          <filter
            id="allowance_model_pending_card_shadow"
            x="-25%"
            y="-25%"
            width="150%"
            height="150%"
          >
            <feDropShadow
              dx="6"
              dy="6"
              stdDeviation="5"
              floodColor="black"
              floodOpacity="0.06"
            />
          </filter>
          <clipPath id="allowance_model_pending_card_clip">
            <rect width="164" height="164" rx="12" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
